import Vue from 'vue'
import App from './App.vue'
import router from "./router/index";
import { Button, Select, Option, OptionGroup, Form, FormItem,Dialog,Input,Radio,RadioGroup,RadioButton,
  Row, Col, Upload, Checkbox, CheckboxButton, CheckboxGroup, Message,} from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import {post,get,request} from './utils/request'
import './assets/iconfont/iconfont.css'

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$request = request;
Vue.prototype.$message = Message;


Vue.use(Button)
Vue.use(Select)
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
